export class State {
  public show: boolean;
  constructor() {
    this.show = true;
  }
}

const state = new State();

export default state;
